// @flow
import React from 'react';

import MemberItem from './MemberItem';
import type { Member } from '../../models/group_chats/Member';

type Props = {
  members: any,
  selectedMembers: Array<Member>,
  onSelectedMembersChange: (members: Array<Member>) => void,
  onModalClose?: Function,
};

export default class MentionButton extends React.PureComponent<Props> {
  handleSelectAll = () => {
    const oldSelectAll =
      this.props.members.length === this.props.selectedMembers.length;
    if (!this.props.onSelectedMembersChange) return;
    this.props.onSelectedMembersChange(oldSelectAll ? [] : this.props.members);
  };

  handleSelectMember = (member: Member) => {
    let { selectedMembers } = this.props;

    if (selectedMembers.includes(member)) {
      selectedMembers = selectedMembers.filter(m => m != member);
    } else {
      selectedMembers = [...selectedMembers, member];
    }

    if (!this.props.onSelectedMembersChange) return;
    this.props.onSelectedMembersChange(selectedMembers);
  };

  onSelectedMembersChange() {
    if (!this.props.onSelectedMembersChange) return;
    this.props.onSelectedMembersChange(this.props.selectedMembers);
  }

  componentDidMount() {
    let observer = new MutationObserver((mutations: any) => {
      if (mutations[0].target.className == 'modal fade') {
        this.props.onModalClose && this.props.onModalClose();
      }
    });
    // $FlowFixMe
    observer.observe(document.querySelector('#mentionModal'), {
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  render() {
    const { members, selectedMembers } = this.props;
    const selectAll = members.length === selectedMembers.length;

    return (
      <div className="mention-btn">
        <label data-toggle="modal" data-target="#mentionModal">
          TO
        </label>
        <div className="modal fade" id="mentionModal" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">メンバーを指定する</h4>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div
                  className={`ml-0 pt-15 pb-15 select-all ${
                    selectAll ? 'select-all--selected' : ''
                  }`}
                  onClick={this.handleSelectAll}
                >
                  <div> 全てのメンバー </div>
                  <div className="select-all__status">
                    {selectAll ? '指名解除' : '指名する'}
                  </div>
                </div>
                <div className="members">
                  {members.map((member, index) => (
                    <MemberItem
                      member={member}
                      key={index}
                      onClick={() => this.handleSelectMember(member)}
                      selected={selectedMembers.includes(member)}
                      selectable
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
